import * as THREE from 'three'
import { types, getParent, Instance, IAnyModelType } from 'mobx-state-tree'
import { Border, generateValueTypeWithLimits } from 'src/api/models/Values/index'
import { IPrintedcircuitboardProperties } from './types'
import { IContentEdge } from '../ContentEdge/types'
import { componentSide, solderSide, printedcircuitboardProperties } from 'src/constants/typenames'
import { generateType } from '../../utils/generateNodeType'
import { buildPlaceholderGeometry } from './buildPlaceholderGeometry'
import { printedcircuitboardParameters } from 'src/constants/parameters'
import { generateLimitedUnitNumber } from 'src/api/models/Values/generateLimitedUnitNumber'

// const AssemblyValue = types.model('AssemblyValue', {
//   height: generateValueTypeWithLimits({ min: 0, max: 240 }),
//   border: Border
// })

// const staticLimits = {
//   width: { min: 1, max: 300 },
//   length: { min: 1, max: 300 },
//   thickness: { min: 1, max: 300 },
//   componentSide: { height: { min: 0, max: 299 } },
//   solderSide: { height: { min: 0, max: 299 } }
// }

// const getProperties = (self: ReturnType<typeof generateValueTypeWithLimits>) => {
//   const parent = getParent<Instance<IContentEdge>>(self, 3)
//   return parent.properties //as Instance<IContentEdgeProperties>
// }

export const PrintedcircuitboardProperties = (): IPrintedcircuitboardProperties =>
  generateType(printedcircuitboardProperties).props({
    width: generateLimitedUnitNumber(printedcircuitboardParameters.properties.width).named(
      'Printedcircuitboard.propterties.width'
    ),
    length: generateLimitedUnitNumber(printedcircuitboardParameters.properties.length).named(
      'Printedcircuitboard.propterties.length'
    ),
    thickness: generateLimitedUnitNumber(printedcircuitboardParameters.properties.thickness).named(
      'Printedcircuitboard.propterties.thickness'
    ),
    componentSide: generateType(componentSide)
      .props({
        height: generateLimitedUnitNumber(
          printedcircuitboardParameters.properties.componentSide.height
        ).named('Printedcircuitboard.propterties.componentSide.height'),
        border: types.optional(
          Border,
          printedcircuitboardParameters.properties.componentSide.border
        )
      })
      .views(self => ({
        get geometry() {
          const properties = getParent<IPrintedcircuitboardProperties>(self)
          return buildPlaceholderGeometry({
            position: 'up',
            properties: {
              width: properties.width,
              length: properties.length,
              thickness: properties.thickness,
              border: self.border,
              element: self.height
            }
          })
        }
      })),
    solderSide: generateType(solderSide)
      .props({
        height: generateLimitedUnitNumber(
          printedcircuitboardParameters.properties.solderSide.height
        ).named('Printedcircuitboard.propterties.solderSide.height'),
        border: types.optional(Border, printedcircuitboardParameters.properties.solderSide.border)
      })
      .views(self => ({
        get geometry() {
          const properties = getParent<IPrintedcircuitboardProperties>(self)
          return buildPlaceholderGeometry({
            position: 'down',
            properties: {
              width: properties.width,
              length: properties.length,
              thickness: properties.thickness,
              border: self.border,
              element: self.height
            }
          })
        }
      }))
  })
